module.exports = __webpack_public_path__ + "media/images/brand/visa-1114b98770fb70fc9f179b15272fbd95.png";